import { render, staticRenderFns } from "./BirthdaysCalendar.vue?vue&type=template&id=100c2a1c&scoped=true&"
import script from "./BirthdaysCalendar.vue?vue&type=script&lang=ts&"
export * from "./BirthdaysCalendar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100c2a1c",
  null
  
)

export default component.exports